module.exports = __webpack_public_path__ + "img/blogthedigitalway.ef02e46c.png";